<template>
  <div id="contenedor-eliminar-contrato-firma">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Firma </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar la Firma? </span>
        <v-divider></v-divider>
        <v-row>
          <span class="font-weight-bold">
            {{firma.funcionario.nombre || ''}}
          </span>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="botonEliminarFirma"
          :disabled="enviandoFormulario"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import mixFirmas from './mixFirmas';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ContenedorEliminarFirma',
  props: {
    firma: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixFirmas],
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    botonEliminarFirma() {
      this.mixEliminarContratoFirma();
    },
  },
  computed: {
  },
};
</script>
